export default __webpack_public_path__ + "static/media/capsule-files-image.769f46c1.svg";